/**
 * Resolves the subscription banner state from the logged in user object.
 *
 * Returning `null` means the bar should not be rendered at all (user not logged in,
 * or the backend did not send any subscription info yet).
 *
 * More conditions (trial, grace period, cancelled, payment failed ...) will be added
 * here as separate blocks, the component itself does not need to change.
 */
export const getSubscriptionStatus = (user) => {
    if (!user) return null;

    // subscription is active.
    if (user?.isSubscribed === true) {
        return {
            key: 'active',
            message: 'Your subscription is active.',
            background: '#E9F9F1',
            border: '#0BD194',
            color: '#0A7A57',
        };
    }

    // subscription has ended.
    if (user?.isSubscribed === false) {
        return {
            key: 'expired',
            message: 'Your subscription has expired.',
            background: '#FDECEC',
            border: '#FF494C',
            color: '#B02427',
        };
    }

    // no subscription information available.
    return null;
};

export default getSubscriptionStatus;
